import React, { useContext, useEffect, useState } from 'react'
import styles from "../../../../Styles/ComponentStyles/GlobalComponentStyles/CustomizeTickerDialog.module.scss"
import globalStyles from "../../../../Styles/global.module.scss"

import Grid from '@mui/material/Grid2';
import { Checkbox, Chip, FormControlLabel, Popper, TextField, Typography } from '@mui/material';
import GlobalButton from '../../../../Utils/Layout/GlobalButton/GlobalButton';
import GlobalSelect from '../../../../Utils/Layout/GlobalSelect/GlobalSelect';
import GlobalAutocomplate from '../../../../Utils/Layout/GlobalAutocomplate/GlobalAutoComplate';
import Icons from '../../../../Utils/Layout/Icons/Icons';
import { DashboardContext, DashboardDetailPayload } from '../../../../Context/DashboardDetailContext';
import agent from '../../../../Services/api';
import { useDebounce } from '../../../../Utils/Hooks/useDebounce';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../../Context/GlobalUserDetailContext';
import { useSnackbar } from '../../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import CloseIcon from '@mui/icons-material/Close';


const CustomizeTickerDialog = (props: any) => {

    const { setTickerCustomizeDialog } = props

    const {
        tickerSaveDetails,
        setTickerSaveDetails,

        storedColorthemeOptions,
        storedDisplayMode,

        selectedStocks,
        setSelectedStocks,

        setTickerSaveDetailsDsh
    } = useContext(DashboardContext) as DashboardDetailPayload

    const {
        setFlagLoader,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { showSnackbar } = useSnackbar();
    const [searchText, setSearchText] = useState('');
    const debouncedSearch = useDebounce(searchText, 500);
    const [searchOptions, setSearchOptions] = useState<any>([]);


    useEffect(() => {
        const triggerSearch = async () => {
            if (debouncedSearch.length < 3) {
                setSearchOptions([]);
                return;
            }
            try {
                setFlagLoader(true)
                const response = await agent.marketSymoboleListSearchString.get(debouncedSearch);
                // Check if response has the correct structure
                if (response?.status && response?.data?.marketSymbols && Array.isArray(response.data.marketSymbols)) {
                    const marketSymbols = response.data.marketSymbols;
                    const formatted = marketSymbols.map((item: any) => ({
                        label: `${item.stockSymbol} - ${item.stockTitle}`,
                        value: item.stockId,
                        stockSymbol: item.stockSymbol,
                        stockTitle: item.stockTitle
                    }));
                    setSearchOptions(formatted);
                    setFlagLoader(false)
                }
                else {
                    console.log("Invalid response structure or no data");
                    setSearchOptions([]);
                    const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
                    showSnackbar(errorMessage, 'error');
                    setFlagLoader(false)
                }

            }
            catch (err) {
                console.error("Search API failed", err);
            }
        };

        triggerSearch();
    }, [debouncedSearch]);

    useEffect(() => {
        fetchSymoboleDetails()
    }, [])

    const fetchSymoboleDetails = async (flagOptional?: boolean) => {
        setFlagLoader(true)

        const response = await agent?.getUserStocksSymboleDetails.get()
        console.log("response of getUserStocksSymboleDetails", response);
        if (response?.status) {
            setFlagLoader(false)
            const { stocks, customizationOptions } = response.data || {};

            const capitalizeFirstLetter = (str: string) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
            const mode = storedDisplayMode.find((d: any) => d.displayName.toLowerCase() == customizationOptions?.displayMode?.toLowerCase());
            const selected = stocks.map((s: any) => ({
                label: `${s.stockSymbol} - ${s.stockTitle}`,
                value: s.stockId,
            }));
            setSelectedStocks(selected);
            setTickerSaveDetails((prev: any) => ({
                ...prev,
                stockIds: selected?.map((s: any) => s.value),
                stokesDetails: stocks,
                customizationOptions: {
                    ...prev.customizationOptions,
                    colorTheme: capitalizeFirstLetter(customizationOptions?.colorTheme ?? ''),
                    displayMode: capitalizeFirstLetter(customizationOptions?.displayMode ?? ''),
                    isLogoVisible: customizationOptions?.isLogoVisible ?? false,
                },
            }));
            if (flagOptional) {
                const filteroutTheme = storedColorthemeOptions?.backgroundColors?.find((ele: any) => ele.name?.toLowerCase() == customizationOptions?.colorTheme?.toLowerCase())
                setTickerSaveDetailsDsh((prev: any) => ({
                    ...prev,
                    stockIds: selected?.map((s: any) => s.value),
                    stokesDetails: stocks,
                    customizationOptions: {
                        ...prev.customizationOptions,
                        bgColor: filteroutTheme?.hex ?? 'black',
                        colorTheme: capitalizeFirstLetter(filteroutTheme?.theme ?? ''),
                        displayMode: capitalizeFirstLetter(customizationOptions?.displayMode ?? ''),
                        isLogoVisible: customizationOptions?.isLogoVisible ?? false,
                    },
                }));
            }
        }
        else {
            setFlagLoader(false)
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
    }

    const handleSaveCustomizeTicker = async () => {

        const payload = {
            stockIds: tickerSaveDetails.stockIds,
            customizationOptions: {
                isLogoVisible: tickerSaveDetails.customizationOptions.isLogoVisible,
                displayMode: tickerSaveDetails.customizationOptions.displayMode?.toLowerCase(),
                colorTheme: tickerSaveDetails.customizationOptions.colorTheme?.toLowerCase()
            }
        };

        setFlagLoader(true)
        const response = await agent?.updateUserTickerDetails?.post(payload)
        console.log("response of updateUserTickerDetails", response);
        if (response?.status) {
            const message = response?.message
            setFlagLoader(false)
            setTickerCustomizeDialog(false)
            fetchSymoboleDetails(true)
            showSnackbar(message, 'success');
        }
        else {
            setFlagLoader(false)
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setTickerCustomizeDialog(false)
        }
    }

    return (
        <>
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ margin: '15px 0px' }}>
                            <Typography component={'span'} className={`${globalStyles.globalTextV15} ${globalStyles.gblCWhite}`}>
                                Settings
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: "15px 0px" }}>
                            <Grid container className={styles.settingsDropdownContainer}>
                                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }}>
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} sx={{ mb: '5px' }}>
                                            <Typography component={'span'} className={`${globalStyles.globalTextV15} ${globalStyles.gblCWhite}`}>
                                                Color Theme
                                            </Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12 }}>
                                            <GlobalSelect
                                                fullWidth
                                                size='small'
                                                className={`${globalStyles.gblDropdownStyles}`}
                                                options={
                                                    storedColorthemeOptions?.backgroundColors?.length ? storedColorthemeOptions?.backgroundColors?.map((ele: any) => ({
                                                        label: ele?.name,
                                                        value: ele?.name
                                                    })) : []
                                                }
                                                value={tickerSaveDetails?.customizationOptions?.colorTheme}
                                                onChange={(e) => {
                                                    setTickerSaveDetails((prev: any) => ({
                                                        ...prev,
                                                        customizationOptions: {
                                                            ...prev.customizationOptions,
                                                            colorTheme: e.target.value,
                                                        },
                                                    }));
                                                }}
                                                renderValue={(selected) => {
                                                    const option = storedColorthemeOptions?.backgroundColors?.find(
                                                        (ele: any) => ele.name === selected
                                                    );
                                                    return option?.name || "";
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }}>
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} sx={{ mb: '5px' }}>
                                            <Typography component={'span'} className={`${globalStyles.globalTextV15} ${globalStyles.gblCWhite}`}>
                                                Display Mode
                                            </Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12 }}>
                                            <GlobalSelect
                                                fullWidth
                                                size='small'
                                                className={`${globalStyles.gblDropdownStyles}`}
                                                options={
                                                    storedDisplayMode?.map((ele: any) => ({
                                                        label: ele.displayName,
                                                        value: ele.displayName,
                                                    }))
                                                }
                                                value={tickerSaveDetails?.customizationOptions?.displayMode}
                                                onChange={(e) => {
                                                    setTickerSaveDetails((prev: any) => ({
                                                        ...prev,
                                                        customizationOptions: {
                                                            ...prev.customizationOptions,
                                                            displayMode: e.target.value,
                                                        },
                                                    }));
                                                }}
                                                renderValue={(selected) => {
                                                    const option = storedDisplayMode.find((ele: any) =>
                                                        ele.displayName == selected
                                                    );
                                                    return option?.displayName || "";
                                                }}

                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 12 }}>
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} sx={{ mb: '5px' }}>
                                            <Typography component={'span'} className={`${globalStyles.globalTextV15} ${globalStyles.gblCWhite}`}>
                                                Logo Visibility
                                            </Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12 }}>
                                            <FormControlLabel
                                                sx={{ color: "#ffffff" }}
                                                label=""
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        icon={<Icons iconName="checkbox" iconWidth="20px" iconHeight="20px" />}
                                                        checkedIcon={<Icons iconName="checkedIcon" iconWidth="20px" iconHeight="20px" />}
                                                        sx={{ padding: "0px 8px", color: "white", }}
                                                        checked={tickerSaveDetails?.customizationOptions?.isLogoVisible}
                                                        onChange={(e) => {
                                                            setTickerSaveDetails((prev: any) => ({
                                                                ...prev,
                                                                customizationOptions: {
                                                                    ...prev.customizationOptions,
                                                                    isLogoVisible: e.target.checked,
                                                                },
                                                            }));
                                                        }}
                                                    />
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: '15px 0px' }}>
                            <Grid container>
                                <Grid size={{ xs: 12 }} sx={{ mb: '5px' }}>
                                    <Typography component={'span'} className={`${globalStyles.globalTextV15} ${globalStyles.gblCWhite}`}>
                                        Symbole Search
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <GlobalAutocomplate
                                        className={`${styles.chipDropdown}`}
                                        multiple
                                        fullWidth
                                        limitTags={4}
                                        value={selectedStocks}
                                        options={searchOptions}
                                        onInputChange={(e: any, value: string) => setSearchText(value)}
                                        onChange={(e, selectedOptions: any) => {
                                            const selectedIds = selectedOptions.map((option: any) => option.value);
                                            setSelectedStocks(selectedOptions); // maintain full selected objects
                                            setTickerSaveDetails((prev: any) => ({
                                                ...prev,
                                                stockIds: selectedIds
                                            }));
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder="Type to search symbol..." variant="outlined" size="small" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            {/* <GlobalAutocomplate
                                multiple
                                fullWidth
                                value={tickerSaveDetails.stockIds}
                                options={searchOptions}
                                onInputChange={(event: any, value: string) => setSearchText(value)} // Fixed: use proper parameters
                                onChange={(_: React.SyntheticEvent, selectedOptions: any) => {
                                    const selectedValues = selectedOptions ? selectedOptions.map((option: any) => option.value) : [];
                                    setTickerSaveDetails((prev: any) => ({
                                        ...prev,
                                        stockIds: selectedValues
                                    }));
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder="Search stocks" variant="outlined" size="small" />
                                )}
                            /> */}
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: "25px 0px 20px" }}>
                            <Grid container sx={{ justifyContent: 'center', gap: '20px' }}>
                                <Grid>
                                    <GlobalButton
                                        variant='outlined'
                                        size='medium'
                                        className={globalStyles.globalButtonOutlinedStyleV1}
                                        value='Close'
                                        onClick={() => { setTickerCustomizeDialog(false) }}
                                    />
                                </Grid>
                                <Grid>
                                    <GlobalButton
                                        variant='contained'
                                        size='large'
                                        className={styles.applyContainedBtn}
                                        value='Apply'
                                        onClick={handleSaveCustomizeTicker}
                                        disabled={!tickerSaveDetails.stockIds.length}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CustomizeTickerDialog